import { Logo } from "app/features/navigation/atoms/Logo";
import { View } from "ui/atoms/view";

export function SplashScreenView() {
    return <View className="absolute top-0 left-0 bottom-0 right-0 flex-1 items-center justify-center bg-white">
        <Logo size="xl" />
    </View>
}